module.exports = __webpack_public_path__ + "assets/img/2021-10.d1cc5b6d.png";